var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed z-10 w-full"},[_c('v-alert',{attrs:{"type":_vm.internetStatus ? 'success' : 'error',"dense":"","value":_vm.show}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }